import { mergeMap } from 'rxjs/operators';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { ServerAction } from '../server.action';
import { ServerTranslator } from '../server.translator';

type IDependencies = IClientApiDependencySegment;

export const createServerStreamEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(ServerAction.createServerStream.started),
  mergeMap((params) => {
    const { payload, resolve, reject } = params;

    return dependencies.api.createServerStream(ServerTranslator.toApiServerStreamCreate(payload)).pipe(
      mergeMap(() => {
        resolve?.();

        return [
          ServerAction.createServerStream.done({ params }),
        ];
      }),
      catchApiError((error) => {
        const isHandled = reject?.(error.errorCode, error.description, error.params);
        return [
          ServerAction.createServerStream.failed({ params, error }),
          ...(isHandled ? [] : [createApiErrorNotification(error)]),
        ];
      }),
    );
  }),
);
